(function($){
    'use strict';

    var $category_selector = $('.news__type select#category');

    $category_selector.bind('change', function () {
        this.form.submit();
    });
     
}(jQuery));